export function stripHtml(text) {
  return String(text || '').replace(/<[^>]+>/g, ' ');
}

export function escapeHtml(text) {
  return String(text == null ? '' : text)
    .split('&').join('&amp;')
    .split('<').join('&lt;')
    .split('>').join('&gt;')
    .split(String.fromCharCode(34)).join('&quot;')
    .split("'").join('&#39;');
}

export function escapeRegExp(text) {
  return String(text).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightTerms(text, terms) {
  const safeTerms = [...new Set((terms || []).map((term) => String(term)))]
    .sort((a, b) => b.length - a.length)
    .map((term) => escapeRegExp(term));
  if (!safeTerms.length) return text;

  const re = new RegExp(`(${safeTerms.join('|')})`, 'gi');
  return String(text).replace(re, '<mark>$1</mark>');
}

export function highlightText(text, terms) {
  return highlightTerms(escapeHtml(text), terms);
}

export function highlightHtml(html, terms) {
  const parts = String(html || '').split(/(<[^>]+>)/g);
  return parts
    .map((part) => (part.startsWith('<') && part.endsWith('>') ? part : highlightTerms(part, terms)))
    .join('');
}
